/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartFunnelH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2c0 1.975 2.255 3.425 6.21 4.272 1.48.317 3.076.523 4.674.637a38.23 38.23 0 0 0 1.897.089L22 7v10h-5.065c-.635.007-1.523.043-2.566.131-1.6.135-3.164.36-4.591.693C6.075 18.69 4 20.103 4 22H2V2zm0 3.88v12.244l.056-.044c1-.767 2.335-1.378 3.943-1.855V7.776c-1.587-.469-2.907-1.068-3.902-1.82zm6 2.389v7.459a35.756 35.756 0 0 1 4.202-.59l-.202.019V8.845a36.288 36.288 0 0 1-3.526-.48zm6 .705.002 6.05c.149-.006.291-.01.427-.014l.496-.01H20V9h-3.068l-.181-.003z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartFunnelH as ChartFunnelH };
